import React from 'react'
import { ColumnBib, ColumnName, ColumnNoc, ColumnResult, ColumnRank, ColumnExpander } from "components/common/TableColumns"
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"
import { createColumnsIntermTeams } from 'components/sports/tri/helper/TriHelpers'
import Label from 'components/general/Label';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStop }from "@fortawesome/free-solid-svg-icons";


export function TableColumnsLive(columnsAdded) {
    let columnsExt = createColumnsIntermTeams(columnsAdded);
    return (
        [
            //ColumnIntermediateRank({ hasIrm: false, config: columnsAdded }),
            ColumnRank({  hasIrm: false, config: columnsAdded  }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnExpander({ type: 'alwaysTrueTri' })
        ]
    )
}


export function TableColumnsLiveSM(columnsAdded) {
    let columnsExt = createColumnsIntermTeams(columnsAdded);
    return (
        [
            //ColumnIntermediateRank({ hasIrm: false, config: columnsAdded }),
            ColumnRank({  hasIrm: false, config: columnsAdded  }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function TableColumnsFinish(columnsAdded) {
    let columnsExt = createColumnsIntermTeams(columnsAdded);
    return (
        [
            ColumnRank({ hasIrm: false, config: columnsAdded }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnResult({ label: "HeaderTotalTime" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function TableColumnsFinishSM(columnsAdded) {
    let columnsExt = createColumnsIntermTeams(columnsAdded);
    return (
        [
            ColumnRank({ hasIrm: false, config: columnsAdded }),
            ColumnBib({ label: "HeaderRaceNo" }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnWarnings({}),
            ...columnsExt,
            ColumnResult({ label: "HeaderTotalTime" }),
            ColumnExpander({ type: 'alwaysTrueTri' })

        ]
    )
}

export function ColumnWarnings({
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = '',
    remove = false
}) {
    return (
        {
            remove: remove,
            Header: (label === '') ? '' : <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            accessor: 'sortOrder',
            id: 'Warnings',
            Cell: (props) => {
                const row = props.cell.row.original;
                return (
                    row?.extendedResults && row?.participant?.code
                        ? <CellCardsFalseStart extendedResults={row?.extendedResults} participant={row?.participant?.code}></CellCardsFalseStart>
                        : ''
                )
            }
        }
    )
}

export const CellCardsFalseStart = React.memo(({ extendedResults, participant }) => {
    let cards = extendedResults.filter(row => row.er_code === 'YC' || row.er_code === 'RC' || row.er_code === 'YRC' || row.er_code === 'PENALTY').map((val, key) => {
        if(val.er_value2 === 'Y' || val.er_value2 === 'S') return <></>
        let penalty = val.er_code === 'PENALTY'
            ? val.er_value === 'Y'
                ? <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-yellow' icon={faStop} /></>
                : <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-red' icon={faStop} /> </>
            : <>
                {val.er_code === 'YC'
                    ? <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-yellow' icon={faStop} /></>
                    : <> <FontAwesomeIcon key={participant + '_Card' + key} className='icon-red' icon={faStop} /> </>
                }
            </>
        return (penalty)
    })

    let falseStarts = extendedResults.filter(row => row.er_code === 'FALSE_START').map((val, key) => {
        let value2 = val.er_value2 ? '(' + val.er_value2 + ')' : "";
        return (<div key={participant + '_FalseStart_' + key}> {val.er_value}{value2}</div>)
    })

    let laneInfrigement = extendedResults.filter(row => row.er_code === 'LANE_INFRINGE').map((val, key) => {
        return (<div key={participant + '_LaneInfringe_' + key}>{val.er_value}</div>)
    })

    let resp = (cards.length > 0 || falseStarts.length > 0 || laneInfrigement.length > 0) ? <>{cards}  {falseStarts} {laneInfrigement}</> : ''
    return (resp)
});